import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performCmdbGetRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
import { getCmdbTempehMigrationUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbTempehMigrationUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { CmdbArchitectureStoreAction } from './ContainerProps.types.tsx';

type TempehMigrationResponse = {
	blockWriteTraffic: boolean;
	routeToTempeh: boolean;
};

export const getMigrationStatus = async (
	workspaceId: WorkspaceId,
): Promise<TempehMigrationResponse> =>
	performCmdbGetRequest<TempehMigrationResponse>(getCmdbTempehMigrationUrl(workspaceId));

export const fetchMigrationStatus =
	(): CmdbArchitectureStoreAction<void> =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		if (getState().loading) {
			return;
		}
		setState({ loading: true });

		try {
			const { blockWriteTraffic, routeToTempeh } = await getMigrationStatus(workspaceId);

			fireTrackAnalytics(createAnalyticsEvent({}), 'fetchMigrationStatus succeeded');

			setState({
				loading: false,
				migrationStatus: {
					blockWriteTraffic,
					routeToTempeh,
				},
			});
		} catch (error) {
			const typedError = error instanceof Error ? error : undefined;
			// We intentionally don't use fireCmdbErrorAnalytics because it's dependent on this store
			fireErrorAnalytics({
				error: typedError,
				meta: {
					id: 'fetchMigrationStatus',
					packageName: 'jiraServicedeskCmdbArchitecture',
					teamName: 'astral',
				},
			});
			setState({ loading: false, error: typedError });
		}
	};
